import OrderByProviders from '../../CasinoGameList/OrderByProviders';
import { GameTagFilter } from '@/models/games/game-tag-filter.enum';
import { useRouter } from 'next/router';

export default function OrderByProvidersRenderer() {
  const { query } = useRouter();
  const tag: GameTagFilter | undefined = query.tag as GameTagFilter;

  if (tag === GameTagFilter.Originals) {
    return null;
  }

  return <OrderByProviders />;
}
